import React, { useEffect, useState, useCallback } from "react";
import { ComboBox, IComboBox } from "@fluentui/react";
import type { IComboBoxOption, IComboBoxStyles } from "@fluentui/react";

export interface MultiSelectComboBoxOption extends IComboBoxOption {}

interface MultiSelectComboProps {
  options: MultiSelectComboBoxOption[];
  label: string;
  onChange: (items: any[]) => any;
  baseTypeProps?: any;
}

export const MultiSelectCombo = (props: MultiSelectComboProps) => {
  const comboBoxStyles: Partial<IComboBoxStyles> = {
    root: { maxWidth: 400, marginRight: 10 },
  };

  const [selectedKeys, setSelectedKeys] = useState<any[]>([]);

  const onChange = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ): void => {
    const selected = option?.selected;
    if (option) {
      const updatedKeys = selected
        ? [...selectedKeys, option!.key as string]
        : selectedKeys.filter((k) => k !== option.key);
      setSelectedKeys(updatedKeys);
    }
  };

  useEffect(() => {
    props.onChange(selectedKeys);
  }, [selectedKeys]);

  return (
    <>
      <ComboBox
        multiSelect
        label={props.label}
        options={props.options}
        styles={comboBoxStyles}
        allowFreeInput
        autoComplete="on"
        allowFreeform
        onChange={onChange}
        selectedKey={selectedKeys}
        {...props.baseTypeProps}
      />
    </>
  );
};
